import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="autofocus"
export default class extends Controller {
  static values = {
    active: { type: Boolean, default: true }
  }

  connect() {
    if (!this.activeValue) return

    this.element.focus()

    if (this.element.setSelectionRange) {
      const length = this.element.value.length
      this.element.setSelectionRange(length, length)
    }
  }
}
